import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { WebsiteService } from 'src/app/_services/website.service';

@Component({
  selector: 'app-capture-lead',
  templateUrl: './capture-lead.component.html',
  styleUrls: ['./capture-lead.component.scss']
})
export class CaptureLeadComponent implements OnInit {
  @Input() resourceUrl: string | null = null
  @Output() formSubmitted = new EventEmitter<string>();
  @Input() resourceTitle: string = '';
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  isSubmitting: boolean = false;
  isPdfResource: boolean = false;
  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private loadScript: LoadScriptService,
    private router: Router,
    private http: HttpClient
  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactphoneNo': ['', Validators.required],
      'DesignationTypes': ['', Validators.required],
      'website': ['']
    });
    }

  ngOnInit(): void {
  }

  sendContactUsForm() {
    if (this.contactForm.value.website) {
      console.warn('Spam detected');
      return;
    }
  
    if (this.contactForm.valid) {
      this.isSubmitting = true;
  
      if (!localStorage.getItem("country-trinka")) {
        this.loadGeoAPIScript();
      }
  
      this.country = localStorage.getItem("country-trinka") || "en";
  
      const query =
        this.contactForm.value.contactFormName + "||" +
        this.contactForm.value.DesignationTypes + "||" +
        this.contactForm.value.contactphoneNo;
  
        this.networkCall.postContactUs(
          this.contactForm.value.contactFormEmail,
          query,
          this.router.url
        ).subscribe(result => {
        sessionStorage.setItem('userEmail', this.contactForm.value.contactFormEmail);
        sessionStorage.setItem('userName', this.contactForm.value.contactFormName);
        // ✅ FIXED
        const fullPdfUrl = 'https://www.trinka.ai' + this.resourceUrl;
        this.isPdfResource = this.resourceUrl?.toLowerCase().includes('.pdf');
        // ✅ Check if it's a PDF before calling API
        if (this.isPdfResource) {

          const emailPayload = {
            email_id: this.contactForm.value.contactFormEmail,
            pdf_url: fullPdfUrl,
            title: this.resourceTitle,
            name: this.contactForm.value.contactFormName
          };

          this.networkCall.sendResourceEmail(emailPayload).subscribe(
            res => console.log('Email sent successfully'),
            err => console.error('Email API failed', err)
          );
        }
  
        // Existing flow
        this.formSection = false;
        this.thankSection = true;
  
        this.formSubmitted.emit(this.resourceUrl);
        this.contactForm.reset();
  
      }, error => {
        this.toastr.warning("Something went wrong!");
      }).add(() => {
        this.isSubmitting = false;
      });
  
    } else {
      this.validateAllFormFields(this.contactForm);
    }
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}
